export default __webpack_public_path__ + "static/media/minigame-1.3e798e6c.gif";